<template>
  <div class="card">
    <div class="card-content widget" :style="style">
      <div class="columns is-mobile is-multiline">
        <div class="column is-4 is-half-mobile">
            <i :class="icon"></i>
        </div>

        <div class="column is-8 is-half-mobile has-text-right">
          <p class="title is-6 is-white">{{ title }}</p>
          <p class="subtitle is-5 is-white">{{ subtitle }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .columns, .column, p, svg {
    color: inherit;
  }
</style>

<script>
export default {
  name: 'WidgetCounter',
  props: {
    icon: {
      required: true,
    },
    title: {
      required: true,
    },
    subtitle: {
      required: true,
    },
    backgroundColor: {
      type: String,
      default: '#1ab394',
    },
    color: {
      type: String,
      default: '#ffffff',
    },
  },
  data() {
    return {
      style: {
        backgroundColor: this.backgroundColor,
        color: this.color,
      },
    };
  },
};
</script>

